import React, { useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router";
import bkstApi from "../../api";
import CloseIcon from "@mui/icons-material/Close";

export default function EditCustomerNotes(props) {
  const { customerId, customer, onUpdate } = props;
  const navigate = useNavigate();

  const [notes, setNotes] = useState("");
  const [open, setOpen] = useState(false);
  const [processing, setProcessing] = useState(false);

  const handleOpen = () => {
    setNotes(customer?.notes || "");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    setProcessing(true);
    bkstApi
      .put(`/my/customer/${customerId}`, { notes })
      .then((res) => {
        if (onUpdate) {
          onUpdate({ ...customer, notes });
        }
        setOpen(false);
        setProcessing(false);
      })
      .catch((error) => {
        console.error("Error saving notes:", error);
        setProcessing(false);
      });
  };

  if (!open) {
    return (
      <IconButton size="small" onClick={handleOpen}>
        <EditIcon fontSize="small" />
      </IconButton>
    );
  } else {
    return (
      <Dialog fullScreen={true} open={open} scroll="paper" onClose={handleClose}>
        <DialogTitle
          sx={{
            padding: "7px 20px",
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0",
            backgroundColor: "#DEDEDE",
            borderBottom: "3px solid #DEDEDE",
          }}
        >
          <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <IconButton onClick={handleClose}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h5">Edit Notes</Typography>
          </Box>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "#F7F7F7" }}>
          <Container maxWidth="sm">
            <Box py={4}>
              <Paper elevation={0}>
                <Box px={2} py={4}>
                  <TextField
                    multiline
                    rows={10}
                    fullWidth
                    variant="outlined"
                    label="Notes"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Add notes about this customer..."
                  />
                </Box>
              </Paper>
              <Box my={2}>
                <Button
                  fullWidth
                  color="primary"
                  variant="contained"
                  onClick={handleSave}
                  disabled={processing}
                >
                  {processing ? "Saving..." : "Save Notes"}
                </Button>
              </Box>
            </Box>
          </Container>
        </DialogContent>
        {processing && (
          <Backdrop open={true} style={{ zIndex: "1000", color: "#fff" }}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </Dialog>
    );
  }
}
